import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import { FlightSearchRecommendation } from './model'

export const FlightSearchesApi = {
  getSearches() {
    return clientApi.get<Response<FlightSearchRecommendation[]>>(
      'flights/searches',
    )
  },
}
